import { Permissions } from 'utils/user/types';
import { AVAILABLE_PAGES_ENUM, PAGES_ENUM, PERMISSION_ENUM, ROUTE_GROUPS_ENUM } from 'routes/enums';
import { PageNotMappedError } from 'routes/errors';
import groupMap from 'routes/routeGroupMaps';

export const mapAvailablePageToBackendPermittedPage = (
  routeGroup: ROUTE_GROUPS_ENUM,
  pageName: AVAILABLE_PAGES_ENUM,
): PAGES_ENUM | never => {
  const permissionGroup = groupMap.get(routeGroup);

  if (!permissionGroup) throw PageNotMappedError();

  const backendPermittedPage = permissionGroup.get(pageName);

  if (!backendPermittedPage) throw PageNotMappedError();

  return backendPermittedPage;
};

export const createPublicPermissions = (): Permissions => ({
  [PAGES_ENUM.ADVISERS_LIST]: [PERMISSION_ENUM.NOT_LOGGED],
  [PAGES_ENUM.APPLICATION_FLOW]: [],
  [PAGES_ENUM.APPLICATION_LIST]: [],
  [PAGES_ENUM.APPLICATION_SUMMARY]: [],
  [PAGES_ENUM.CLUBS_LIST]: [],
  [PAGES_ENUM.DASHBOARD]: [],
  [PAGES_ENUM.FIRMS_LIST]: [PERMISSION_ENUM.NOT_LOGGED],
  [PAGES_ENUM.NETWORKS_LIST]: [],
  [PAGES_ENUM.MANAGERS_LIST]: [],
  [PAGES_ENUM.PROFILE]: [],
  [PAGES_ENUM.REGISTER_ADVISER_AND_SUPPORT]: [],
  [PAGES_ENUM.REGISTER_FIRM_AND_MANAGER]: [],
  [PAGES_ENUM.QUICK_ESIS_FLOW]: [],
  [PAGES_ENUM.BLANK]: [],
  [PAGES_ENUM.PRODUCT_RESELECT]: [],
  [PAGES_ENUM.ADMIN_PANEL]: [],
  [PAGES_ENUM.MBC]: [],
  [PAGES_ENUM.FMA]: [],
  [PAGES_ENUM.AF_TOOL]: [],
  [PAGES_ENUM.CASE]: [],
  [PAGES_ENUM.TRIAGE]: [],
  [PAGES_ENUM.REGISTER]: [PERMISSION_ENUM.NOT_LOGGED],
  [PAGES_ENUM.ORGANIZATION_DETAILS]: [],
});
